import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserPreferencesPayload } from '../utils/userPreferences.service';

interface UserPreferencesState {
  modelPref: string | null;
  fontSize: string | null;
  bubbleColor: string | null;
  isLoading: boolean;
  hasFetched: boolean;
}

const initialState: UserPreferencesState = {
  modelPref: null,
  fontSize: null,
  bubbleColor: null,
  isLoading: false,
  hasFetched: false,
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setPrefsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setUserPreferences(state, action: PayloadAction<Pick<UserPreferencesPayload, 'modelPref' | 'fontSize' | 'bubbleColor'>>) {
      if (action.payload.modelPref !== undefined) {
        state.modelPref = action.payload.modelPref;
      }
      if (action.payload.fontSize !== undefined) {
        state.fontSize = action.payload.fontSize;
      }
      if (action.payload.bubbleColor !== undefined) {
        state.bubbleColor = action.payload.bubbleColor;
      }
      state.hasFetched = true;
      state.isLoading = false;
    },
  },
});

export const { setPrefsLoading, setUserPreferences } = userPreferencesSlice.actions;
export default userPreferencesSlice.reducer;
